import { Text, useTheme } from "@fluentui/react";

import {
  ContractOccurrence,
  ContractOccurrenceItem,
  ContractsActionsLogsType,
  ContractsActionsLogsTypeDotColor,
  ContractsActionsLogsTypeMessage
} from "./ContractOccurrences.interfaces";

import { SharedLogRow } from "@/components/Shared/LogRow";
import { phoneNumberFormatter } from "@/utils/PhoneNumberFormatter";

interface ContractLogRowProps {
  occurrence: ContractOccurrence;
}

function isContractOccurrenceItem(
  occurrence: ContractOccurrence
): occurrence is ContractOccurrenceItem {
  return (
    occurrence.contractItem !== null &&
    (occurrence.logType === ContractsActionsLogsType.ITEM_ADDED ||
      occurrence.logType === ContractsActionsLogsType.ITEM_REMOVED)
  );
}

const BoldText = ({ text }: { text: string }) => (
  <Text styles={{ root: { fontWeight: 600, marginRight: 4 } }}>{text}</Text>
);

const RenderItemInformation = (occurrence: ContractOccurrence) => {
  if (!isContractOccurrenceItem(occurrence)) return null;

  return (
    <Text styles={{ root: { marginTop: 8, fontSize: 12 } }}>
      {occurrence.contractItem.line && (
        <>
          <BoldText text="Linha:" />
          {phoneNumberFormatter(occurrence.contractItem.line.number)}
          <br />
        </>
      )}
      {occurrence.contractItem.offerPrice && (
        <>
          <BoldText text="Plano de benefícios:" />
          {occurrence.contractItem.offerPrice.offer.plan.name}
          <br />
          <BoldText text="Pacote de Benefícios:" />
          {occurrence.contractItem.offerPrice.offer.combo}
          <br />
        </>
      )}
      {occurrence.contractItem.inventory?.length &&
        occurrence.contractItem.inventory.map((inventory, index) => (
          <div key={index}>
            <BoldText text="Benefício combos:" />
            {inventory.product?.name}
            <br />
            <BoldText text="Tipo de série:" />
            {inventory.serialType}
            <br />
            <BoldText text="Número de série:" />
            {inventory.serialNumber}
            <br />
          </div>
        ))}
    </Text>
  );
};

function ContractLogRow({ occurrence }: ContractLogRowProps) {
  const theme = useTheme();

  return (
    <SharedLogRow
      iconColor={
        ContractsActionsLogsTypeDotColor[occurrence.logType] ||
        theme.palette.neutralSecondary
      }
      title={ContractsActionsLogsTypeMessage[occurrence.logType]}
      statusChangeReason={occurrence.statusChangeReason}
      currentStep={occurrence.currentStep}
      nextStep={occurrence.nextStep}
      user={occurrence.user}
      createdAt={occurrence.createdAt}
    >
      {RenderItemInformation(occurrence)}
    </SharedLogRow>
  );
}

export default ContractLogRow;
